import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);
function pinFunction() {
	if($(".wp-block-thefuturblocks-pin").length) {
		$(".wp-block-thefuturblocks-pin").each(function() {
			var self = $(this),
				cont = self.find(".wp-block-thefuturblocks-pin__content"),
				contData = cont.attr("data-anim"),
				active = self.find(".wp-block-thefuturblocks-pin-active"),
				holder = self.find(".wp-block-thefuturblocks-pin-active__holder"),
				passive = self.find(".wp-block-thefuturblocks-pin-passive"),
				passHeight = self.outerHeight(),
				actHeight = holder.outerHeight(),
				height = passHeight - actHeight;

			let animStartPos = 'top center';
			let animEndPos = 'center';

			if(contData == 'anim-t') {
				animStartPos = 'top +=120';
				animEndPos = '+=120';
			}

			ScrollTrigger.matchMedia({
				// desktop
				"(min-width: 1024px)": function() {
					// setup animations and ScrollTriggers for screens over 800px wide (desktop) here...
					// ScrollTriggers will be reverted/killed when the media query doesn't match anymore.
				    var tl = gsap.to(active,{y:height,ease:"none"});
					var st = ScrollTrigger.create({
						trigger: passive,
						start: animStartPos,
						end: `+=${height} ${animEndPos}`,
						scrub: 1,
						animation: tl
					});
				}
			});
		});
	}
}
$(window).on('load', pinFunction);